<template>
  <transition name="fade" mode="out-in">
    <div class="library-font lib-msg-box" v-if="show">
      <div class="box">
        <div class="body">
          <img v-if="type === 'warning'" class="icon" src="../../assets/img/msg-box/question_fill.svg" alt="icon" />
          <img v-if="type === 'info'" class="icon" src="../../assets/img/msg-box/info_fill.svg" alt="icon" />
          <img v-if="type === 'infoYellow'" class="icon" src="../../assets/img/msg-box/info_icon.svg" alt="icon" />
          <img v-if="type === 'success'" class="icon" src="../../assets/img/msg-box/success-filling.svg" alt="icon" />
          <img v-if="type === 'error'" class="icon" src="../../assets/img/msg-box/exclamation.svg" alt="icon" />
          <div class="content">
            <div class="title">{{ title }}</div>
            <div v-if="!dangerouslyUseHTMLString" class="message">{{ message }}</div>
            <div v-else class="message" v-html="message"></div>
          </div>
        </div>
        <div class="footer">
          <el-button v-if="showCancelButton" size="small" @click="cancel">{{ cancelButtonText }}</el-button>
          <el-button v-if="showConfirmButton" class="confirm-btn" size="small" @click="confirm">{{
            confirmButtonText
          }}</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LibMsgBox",
  data() {
    return {
      show: this.show,
      title: this.$options.title,
      message: this.$options.message,
      type: this.$options.type,
      showClose: this.$options.showClose,
      distinguishCancelAndClose: this.$options.distinguishCancelAndClose,
      showCancelButton: this.$options.showCancelButton,
      showConfirmButton: this.$options.showConfirmButton,
      cancelButtonText: this.$options.cancelButtonText,
      confirmButtonText: this.$options.confirmButtonText,
      closeOnClickModal: this.$options.closeOnClickModal,
      closeOnPressEscape: this.$options.closeOnPressEscape,
      dangerouslyUseHTMLString: this.$options.dangerouslyUseHTMLString,
    };
  },
  components: {},
  methods: {
    cancel() {
      this.cancel();
    },
    confirm() {
      this.confirm();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/config.scss";

.lib-msg-box {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;

  display: flex;
  justify-content: center;
  align-items: center;

  .box {
    width: 438px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    padding: 32px 32px 24px 32px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .body {
      display: flex;

      .icon {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        font-size: 22px;
        color: #faad14;
      }

      .content {
        margin-left: 16px;

        .title {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }

        .message {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;

          margin-top: 16px;
          margin-bottom: 16px;
        }
      }
    }

    .footer {
      display: flex;
      justify-content: flex-end;

      .confirm-btn {
        color: $theme-color;
        border-color: $theme-color;
      }
    }
  }
}
</style>
